/* istanbul ignore file */
/**
 * Chip component theme configuration.
 */

export const chipComponentConfig = {
  chip: {
    root: {
      borderRadius: 'border.radius.none',
      paddingX: '8px',
      paddingY: '2px',
      gap: '4px',
      transitionDuration: '{transition.duration}',
    },
    image: {
      width: '16px',
      height: '16px',
    },
    icon: {
      size: '12px',
    },
    removeIcon: {
      size: '12px',
      focusRing: {
        width: '{focus.ring.width}',
        style: '{focus.ring.style}',
        color: '{focus.ring.color}',
        offset: '{focus.ring.offset}',
        shadow: '{form.field.focus.ring.shadow}',
      },
    },
    colorScheme: {
      light: {
        root: {
          background: '{surface.0}',
          color: '{surface.900}',
          //border: '{coralreef.600}',
        },
        icon: {
          color: '{surface.800}',
        },
        removeIcon: {
          color: '{surface.800}',
        },
      },
      // dark: {
      //   root: {
      //     background: '{surface.700}',
      //     color: '{surface.0}',
      //   },
      //   icon: {
      //     color: '{surface.0}',
      //   },
      //   removeIcon: {
      //     color: '{surface.0}',
      //   },
      // },
    },
  },
};
